<div class="row align-items-start mb-4">
    <div class="col-auto">
        <app-back-button [route]="backRoute"></app-back-button>
    </div>
    <div class="col-auto mx-auto">
        <h5>{{ "PAGES.TOURNAMENT-DETAILS" | translate }}</h5>
    </div>
    <div class="col-auto" style="width: 60px"></div>
</div>
<section class="bg-white p-4" [nbSpinner]="loading">
    <div class="h-tournament" *ngIf="tournament">
        <div class="d-flex flex-column flex-md-row align-items-center justify-content-between">
            <div class="d-flex flex-wrap align-items-center">
                <nb-tag-list>
                    <nb-tag
                        [status]="tournamentStatusColor"
                        [text]="tournament.detail.descricao_situacao"
                        appearance="filled"
                        size="small"
                    ></nb-tag>
                </nb-tag-list>
                <span class="divider vertical"></span>
                <div class="h-tournament-creator">
                    <img [src]="tournament.detail.url_avatar" [alt]="tournament.detail.por" />
                    <span>{{ "GENERAL.CREATED-BY" | translate }} {{ tournament.detail.por }}</span>
                </div>
            </div>

            <div class="h-tournament-actions">
                <button
                    *ngIf="hasSubscription"
                    [routerLink]="['./category/cancel']"
                    [disabled]="tournament.detail.disabled_cancelar"
                    status="danger"
                    nbButton
                >
                    {{ "BUTTONS.CANCEL-SUBSCRIPTION" | translate }}
                </button>
                <button
                    *ngIf="shouldLogin"
                    nbButton
                    status="basic"
                    routerLink="/auth/login"
                    [queryParams]="{
                        redirect: '/' + tournament.detail.route + '/tournament' + '/' + tournament.detail.id_torneio
                    }"
                    nbTooltip="{{ 'TOURNAMENT.SUBSCRIBE-LOGGED' | translate }}"
                    nbTooltipStatus="primary"
                >
                    {{ "BUTTONS.LOGIN" | translate }}
                    <nb-icon icon="log-in-outline"></nb-icon>
                </button>
                <button
                    nbButton
                    status="primary"
                    [routerLink]="['./category/select']"
                    [disabled]="tournament?.detail?.disabled?.disabled"
                    class="ml-md-2"
                    *ngIf="!shouldLogin"
                >
                    {{ "BUTTONS.SUBSCRIBE" | translate }}
                    <nb-icon icon="arrow-forward-outline"></nb-icon>
                </button>
            </div>
        </div>

        <div class="d-flex flex-column flex-md-row align-items-start mb-4">
            <h1 class="h-tournament-title">
                {{ tournament.detail.nome_torneio }}
            </h1>
        </div>

        <nb-alert outline="info" class="flex-row align-items-center" *ngIf="tournament.detail.payments">
            <nb-icon icon="alert-circle-outline" class="mr-2"></nb-icon>
            {{ tournament.detail.payments }}
            <button nbButton size="small" class="ml-auto" [routerLink]="['/user/finances']">
                {{ "BUTTONS.PAY" | translate }}
            </button>
        </nb-alert>

        <div class="h-tournament-info">
            <div class="info-block">
                <div class="info-block__content">
                    <div class="d-flex flex-wrap justify-content-center justify-content-md-between">
                        <p class="info-block__title">
                            {{ "GENERAL.SUBSCRIPTIONS" | translate }} {{ "GENERAL.UNTIL" | translate }}
                        </p>
                        <nb-icon
                            [ngClass]="[isCbt() ? 'info-block__icon icon--asterisk' : 'info-block__icon']"
                            icon="clock-outline"
                            [nbTooltip]="isCbt() ? '*Horário de brasília' : null"
                        ></nb-icon>
                    </div>
                    <p class="info-block__description">
                        {{ tournament.detail.dt_final_insc }}
                        <span *ngIf="tournament.detail.hr_final_inscricoes">
                            - {{ tournament.detail.hr_final_inscricoes }}<span class="asterisk" *ngIf="isCbt()">*</span>
                        </span>
                    </p>
                </div>
            </div>
            <div class="info-block">
                <div class="info-block__content">
                    <div class="d-flex flex-wrap justify-content-center justify-content-md-between">
                        <p class="info-block__title">{{ "GENERAL.EXPECTED-PERIOD" | translate }}</p>
                        <nb-icon class="info-block__icon" icon="calendar-outline"></nb-icon>
                    </div>
                    <p class="info-block__description">
                        {{ tournament.detail.dt_inicio }}
                        <span *ngIf="tournament.detail.dt_final">- {{ tournament.detail.dt_final }}</span>
                    </p>
                </div>
            </div>
            <div class="info-block">
                <div class="info-block__content">
                    <p class="info-block__title">{{ "GENERAL.CANCEL-UNTIL" | translate }}</p>
                    <p class="info-block__description">
                        {{ tournament.detail.dt_final_cancelamento }}
                        <span *ngIf="tournament.detail.hr_final_inscricoes">
                            - {{ tournament.detail.hr_final_cancelamento
                            }}<span class="asterisk" *ngIf="isCbt()">*</span>
                        </span>
                    </p>
                </div>
                <nb-icon
                    [ngClass]="[isCbt() ? 'info-block__icon icon--asterisk' : 'info-block__icon']"
                    icon="person-delete-outline"
                    [nbTooltip]="isCbt() ? '*Horário de brasília' : null"
                ></nb-icon>
            </div>
            <div class="info-block">
                <div class="info-block__content">
                    <p class="info-block__title">{{ "GENERAL.LOCAL" | translate }}</p>
                    <p class="info-block__description">{{ tournament.detail.cidade }} - {{ tournament.detail.uf }}</p>
                </div>
                <nb-icon class="info-block__icon" icon="pin-outline"></nb-icon>
            </div>
        </div>

        <!-- VALORES DAS INSCRIÇÕES -->
        <div class="h-tournament-list" *ngIf="tournament.values">
            <div
                class="h-tournament-list-header"
                [class.list-active]="!collapse.inscricoes"
                (click)="collapse.inscricoes = !collapse.inscricoes"
            >
                <fa-icon [icon]="icons.caretRight"></fa-icon>
                <span>{{ "GENERAL.SUBSCRIPTIONS-VALUES" | translate }}</span>
            </div>
            <div
                class="h-tournament-list-item h-tournament-list-item-oblique"
                *ngFor="let subsValue of tournament.values"
                [ngbCollapse]="collapse.inscricoes"
            >
                <div class="h-tournament-list-category">
                    <div>
                        <fa-icon [icon]="icons.money"></fa-icon>
                        <span
                            >{{ "GENERAL.VALUE-IN" | translate }} {{ subsValue.nr_inscricoes }}ª
                            {{ "GENERAL.SUBSCRIPTION" | translate }}</span
                        >
                    </div>
                    <div class="d-flex align-items-center mr-lg-5">
                        <div class="mr-2 mr-md-4">
                            <span class="d-block text-primary text-center">
                                <strong>{{ "GENERAL.VALUE" | translate }}</strong>
                                <span class="d-block text-center">{{ subsValue.valor }}</span>
                            </span>
                        </div>
                        <div class="mr-2">
                            <span class="d-block text-primary">
                                <strong>{{ "GENERAL.VALUE-DISCOUNT" | translate }}</strong>
                                <span class="d-block text-center">{{ subsValue.valor_com_desconto }}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- PROGRAMA DO TORNEIO -->
        <div class="h-tournament-list">
            <div class="h-tournament-list-header list-active" (click)="collapse.program = !collapse.program">
                <fa-icon [icon]="icons.caretRight"></fa-icon>
                <span>{{ "TOURNAMENT.TOURNAMENT-PROGRAM" | translate }}</span>
            </div>
            <div
                class="h-tournament-list-item"
                [routerLink]="
                    tournament.detail.programa_publicado
                        ? ['/tournaments-central', tournament.detail.id_torneio, 'program']
                        : null
                "
                [style.cursor]="tournament.detail.programa_publicado ? 'pointer' : 'default'"
                [ngbCollapse]="collapse.program"
            >
                <ng-container *ngIf="tournament.detail.programa_publicado">
                    {{ "TOURNAMENT.VIEW-TOURNAMENT-PROGRAM" | translate }}
                    <nb-icon icon="diagonal-arrow-right-up-outline"></nb-icon>
                </ng-container>
                <ng-container *ngIf="!tournament.detail.programa_publicado">
                    {{ "TOURNAMENT.WAITING-TOURNAMENT-PROGRAM" | translate }}
                    <nb-icon icon="clock-outline"></nb-icon>
                </ng-container>
            </div>
        </div>
        <!-- PONTUAÇÃO -->
        <div class="h-tournament-list" *ngIf="tournament.points">
            <div class="h-tournament-list-header list-active" (click)="collapse.pontuacao = !collapse.pontuacao">
                <fa-icon [icon]="icons.caretRight"></fa-icon>
                <span>{{ "TOURNAMENT.POINTS" | translate }}</span>
            </div>
            <nb-card class="point-table-card" [nbSpinner]="loadingPoints">
                <nb-card-header>
                    <div class="form-control-group">
                        <label for="points-category" class="mr-2"
                            ><strong>{{ "TOURNAMENT.POINT-CATEGORY" | translate }}:</strong></label
                        >
                        <nb-select
                            id="points-category"
                            [(ngModel)]="pointsSelectedCategory"
                            (ngModelChange)="onPointsCategoryChange($event)"
                        >
                            <nb-option
                                *ngFor="let category of tournament.points.categorias | keyvalue"
                                [value]="category.key"
                            >
                                {{ category.value }}
                            </nb-option>
                        </nb-select>
                    </div>
                    <span
                        ><strong>{{ "GENERAL.RANKING" | translate }}:</strong> {{ points.nome_ranking }}</span
                    >
                    <span
                        ><strong>{{ "TOURNAMENT.POINT-GROUP" | translate }}:</strong> {{ points.descricao }}</span
                    >
                </nb-card-header>
                <nb-card-body>
                    <nb-list class="point-table" *ngIf="points?.tabela">
                        <nb-list-item *ngIf="points.tabela['9']">
                            <span>Campeão</span>
                            <span>{{ points.tabela["9"] }}</span>
                        </nb-list-item>
                        <nb-list-item *ngIf="points.tabela['8']">
                            <span>Vice-campeão</span>
                            <span>{{ points.tabela["8"] }}</span>
                        </nb-list-item>
                        <nb-list-item *ngIf="points.tabela['6']">
                            <span>Semi</span>
                            <span>{{ points.tabela["6"] }}</span>
                        </nb-list-item>
                        <nb-list-item *ngIf="points.tabela['5']">
                            <span>Quartas</span>
                            <span>{{ points.tabela["5"] }}</span>
                        </nb-list-item>
                        <nb-list-item *ngIf="points.tabela['4']">
                            <span>Oitavas</span>
                            <span>{{ points.tabela["4"] }}</span>
                        </nb-list-item>
                        <nb-list-item *ngIf="points.tabela['3']">
                            <span>16ª finais</span>
                            <span>{{ points.tabela["3"] }}</span>
                        </nb-list-item>
                        <nb-list-item *ngIf="points.tabela['2']">
                            <span>Segunda rodada</span>
                            <span>{{ points.tabela["2"] }}</span>
                        </nb-list-item>
                        <nb-list-item *ngIf="points.tabela['1']">
                            <span>Primeira rodada</span>
                            <span>{{ points.tabela["1"] }}</span>
                        </nb-list-item>
                    </nb-list>
                </nb-card-body>
            </nb-card>
        </div>

        <!-- CATEGORIAS-->
        <div class="h-tournament-list h-tournament-list--categories">
            <app-tournament-categories></app-tournament-categories>
        </div>

        <!-- LOCAIS DOS JOGOS -->
        <div class="h-tournament-list" *ngIf="tournament.local">
            <div
                class="h-tournament-list-header"
                [class.list-active]="!collapse.locais"
                (click)="collapse.locais = !collapse.locais"
            >
                <fa-icon [icon]="icons.caretRight"></fa-icon>
                <span>{{ "GENERAL.GAME-LOCATION" | translate }}</span>
            </div>
            <div class="h-tournament-list-item" *ngFor="let local of tournament.local" [ngbCollapse]="collapse.locais">
                <div class="d-flex flex-column">
                    <div>
                        <fa-icon [icon]="icons.marker"></fa-icon>
                        <span>{{ local.nome_abreviado }}</span>

                        <span class="opacity-60">
                            / {{ local.endereco }}, {{ local.numero }} - {{ local.nome_cidade }},
                            {{ local.sigla }}</span
                        >
                    </div>
                    <div>
                        <fa-icon [icon]="icons.email" class="opacity-60" *ngIf="local.email"></fa-icon>

                        <span class="opacity-60" *ngIf="local.email">{{ local.email }}</span>
                        <span class="opacity-60" *ngIf="local.fone_com_numero"> / </span>

                        <fa-icon [icon]="icons.phone" class="opacity-60" *ngIf="local.fone_com_numero"></fa-icon>

                        <span class="opacity-60" *ngIf="local.fone_com_numero"
                            >{{ local.fone_com_ddd }} {{ local.fone_com_numero }}</span
                        >
                    </div>
                </div>
                <div class="d-flex flex-wrap align-items-center">
                    <div class="local-aditional-info" *ngIf="tournament.detail.dados_bola_jogo">
                        <span class="mr-1">{{ "TOURNAMENT.GAME-BALL" | translate }}:</span>
                        <span class="mr-1">
                            <strong>{{ tournament.detail.dados_bola_jogo }}</strong>
                        </span>
                    </div>

                    <div class="local-aditional-info" *ngIf="local.tipo_piso_1">
                        <span class="mr-1">{{ "TOURNAMENT.FLOOR-TYPE" | translate }}:</span>
                        <span class="mr-1">
                            <strong>{{ local.tipo_piso_1 }}</strong>
                        </span>
                        <span class="opacity-60"> / </span>
                        <span class="mr-1">{{ "TOURNAMENT.COURTS-QNT" | translate }}:</span>
                        <span>
                            <strong>{{ local.qtd_quadras_jogo_1 }}</strong>
                        </span>
                    </div>

                    <div class="local-aditional-info" *ngIf="local.tipo_piso_2">
                        <span class="mr-1">{{ "TOURNAMENT.FLOOR-TYPE" | translate }}:</span>
                        <span class="mr-1">
                            <strong>{{ local.tipo_piso_2 }}</strong>
                        </span>
                        <span class="opacity-60"> / </span>
                        <span class="mr-1">{{ "TOURNAMENT.COURTS-QNT" | translate }}:</span>
                        <span>
                            <strong>{{ local.qtd_quadras_jogo_2 }}</strong>
                        </span>
                    </div>

                    <div class="local-aditional-info" *ngIf="local.tipo_piso_3">
                        <span class="mr-1">{{ "TOURNAMENT.FLOOR-TYPE" | translate }}:</span>
                        <span class="mr-1">
                            <strong>{{ local.tipo_piso_3 }}</strong>
                        </span>
                        <span class="opacity-60"> / </span>
                        <span class="mr-1">{{ "TOURNAMENT.COURTS-QNT" | translate }}:</span>
                        <span>
                            <strong>{{ local.qtd_quadras_jogo_3 }}</strong>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- HOTEIS -->
        <div class="h-tournament-list" *ngIf="tournament.detail.hoteis?.length">
            <div
                class="h-tournament-list-header"
                [class.list-active]="!collapse.hoteis"
                (click)="collapse.hoteis = !collapse.hoteis"
            >
                <fa-icon [icon]="icons.caretRight"></fa-icon>
                <span>{{ "TOURNAMENT.HOTELS" | translate }}</span>
            </div>
            <div
                class="h-tournament-list-item"
                *ngFor="let hotel of tournament.detail.hoteis"
                [ngbCollapse]="collapse.hoteis"
            >
                <div class="d-flex flex-column">
                    <div style="margin-bottom: 4px">
                        <span>{{ hotel.hotel }}</span>
                    </div>
                    <div style="margin-bottom: 2px">
                        <fa-icon [icon]="icons.marker" class="opacity-60"></fa-icon>

                        <span class="opacity-60">
                            {{ hotel.endereco }}
                        </span>
                    </div>
                    <div>
                        <fa-icon [icon]="icons.email" class="opacity-60" *ngIf="hotel.email"></fa-icon>

                        <span class="opacity-60" *ngIf="hotel.email">{{ hotel.email }}</span>
                        <span class="opacity-60" *ngIf="hotel.nr_fone"> / </span>

                        <fa-icon [icon]="icons.phone" class="opacity-60" *ngIf="hotel.nr_fone"></fa-icon>

                        <span class="opacity-60" *ngIf="hotel.nr_fone">{{ hotel.nr_fone }}</span>
                    </div>
                    <div
                        [innerHTML]="hotel.demais_informacoes"
                        *ngIf="!isHtmlContentEmpty(hotel.demais_informacoes)"
                        class="hotel-info"
                    ></div>
                </div>
            </div>
        </div>

        <!-- DEPARTAMENTO E ARBITRAGEM -->
        <div class="h-tournament-list" *ngIf="tournament.direction">
            <div
                class="h-tournament-list-header"
                [class.list-active]="!collapse.departamento"
                (click)="collapse.departamento = !collapse.departamento"
            >
                <fa-icon [icon]="icons.caretRight"></fa-icon>
                <span>{{ "GENERAL.DEPARTMENT-ARBITRATION" | translate }}</span>
            </div>
            <div
                class="h-tournament-list-item"
                *ngFor="let arbitration of tournament.direction"
                [ngbCollapse]="collapse.departamento"
            >
                <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                        <img
                            width="32"
                            height="32"
                            class="border-radius-100 mr-2"
                            [src]="arbitration.url_avatar"
                            [alt]="arbitration.nome"
                        />
                        <div>
                            <span>{{ arbitration.nome }}</span>
                            <div>
                                <fa-icon [icon]="icons.email" class="opacity-60" *ngIf="arbitration.email"></fa-icon>
                                <span class="opacity-60 mr-2">{{ arbitration.email }}</span>
                                <fa-icon [icon]="icons.phone" class="opacity-60" *ngIf="arbitration.nr_fone"></fa-icon>
                                <span class="opacity-60" *ngIf="arbitration.nr_fone">{{ arbitration.nr_fone }}</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <span class="font-weight-bold mr-2 mr-lg-5 opacity-60">{{ arbitration.funcao }}</span>

                        <span class="font-weight-bold mr-2 mr-lg-5 opacity-60">{{ arbitration.uf }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- ANEXOS-->
        <div class="h-tournament-list" *ngIf="tournament.docs?.length">
            <div
                class="h-tournament-list-header"
                [class.list-active]="!collapse.anexos"
                (click)="collapse.anexos = !collapse.anexos"
            >
                <fa-icon [icon]="icons.caretRight"></fa-icon>
                <span>Anexos</span>
            </div>
            <div class="h-tournament-list-item" *ngFor="let doc of tournament.docs" [ngbCollapse]="collapse.anexos">
                <a [href]="doc.url_anexo" target="_blank" rel="noopener noreferrer">
                    <fa-icon [icon]="icons.pdf"></fa-icon>
                    <span>{{ doc.descricao }}</span>
                </a>
            </div>
        </div>

        <!-- REGULAMENTO -->
        <div class="h-tournament-list" *ngIf="tournament.regulation">
            <div
                class="h-tournament-list-header"
                [class.list-active]="!collapse.regulation"
                (click)="collapse.regulation = !collapse.regulation"
            >
                <fa-icon [icon]="icons.caretRight"></fa-icon>
                <span>{{ "TOURNAMENT.DETAILS.REGULATION" | translate }}</span>
            </div>
            <div class="content content-small" [ngbCollapse]="collapse.regulation">
                <div [innerHTML]="tournament.regulation"></div>
            </div>
        </div>

        <!-- INFORMAÇÕES/OBSERVAÇÕES -->
        <div class="h-tournament-list" *ngIf="tournament.obs.home.texto">
            <div
                class="h-tournament-list-header"
                [class.list-active]="!collapse.infos"
                (click)="collapse.infos = !collapse.infos"
            >
                <fa-icon [icon]="icons.caretRight"></fa-icon>
                <span
                    >{{ "TOURNAMENT.DETAILS.INFORMATION" | translate }}/{{
                        "TOURNAMENT.DETAILS.REMARKS" | translate
                    }}</span
                >
            </div>
            <div class="content content-small" [ngbCollapse]="collapse.infos">
                <h2>{{ tournament.obs.home.titulo }}</h2>
                <div [innerHTML]="tournament.obs.home.texto"></div>
            </div>
        </div>
    </div>
</section>
